import {memo} from "react";
import {Link} from "react-router-dom";
import "./index.scss";


const Support = () => {
    return (
        <div className="support">
            <h4 className="support__title">Не нашли решение?</h4>
            <p className="support__text">Опишите ситуацию - наша команда <br/>с радостью поможет вам.</p>
            <Link to="/help" className="support__button">Обратиться в поддержку</Link>
        </div>
    );
};

export default memo(Support);